import { AppState, TableState } from '../state';

export const selectTable = (state: AppState): TableState => state.table;
